<template>
  <div class="switchers">
    <button
      class="switchLayer switchLayer--color"
      v-show="
        tileStatus(layer.isActive, general.layout.layersShowAll, layer.phaseId)
      "
      v-bind:class="{ 'switchLayer--active': layer.isActive }"
      v-for="layer in layersFiltered"
      :key="layer.id"
      @click="handleClick(layer.id)"
      :style="{ '--color': phases.colors[layer.phaseId] }"
    >
      <span
        v-bind:class="[
          'switchLayer__badge',
          { 'switchLayer__badge--active': layer.isActive }
        ]"
        :style="{ '--color': phases.colors[layer.phaseId] }"
        >{{ layer.phaseId }}</span
      >
      {{ layer.name }}
    </button>
    <!--<button
      class="switchLayer switchLayer--color"
      v-bind:class="{ 'switchLayer--active': layer.isActive }"
      v-for="layerKey in layersSorted"
      :key="layerKey.layerId"
      @click="handleClick(layerKey.layerId)"
    >
      {{ layers[layerKey.layerId].id }}{{ layers[layerKey.layerId].name }}
    </button>-->
    <!--<button @click="showAllLayers()" v-show="!general.layout.layersShowAll">-->
    <button @click="showAllLayers()" class="switchLayer switchLayer--all">
      <span
        class="switchLayer__badge switchLayer__badge--active"
        :style="{ '--color': phases.colors[general.phaseId] }"
        >{{ general.phaseId }}</span
      >
      {{
        general.layout.layersShowAll
          ? 'Skrýt neaktivní z fáze ' + general.phaseId
          : 'Všechny vrstvy fáze ' + general.phaseId
      }}
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  props: {
    layers: {
      type: Array,
      required: true
    }
  },
  created() {
    this.$store.dispatch('phases/fetchColors');
  },
  methods: {
    handleClick(layerId) {
      this.$store.dispatch('layers/toggleGmLayer', layerId);
    },
    showAllLayers() {
      this.$store.dispatch('general/toggleShowAllLayersStatus');
    },
    tileStatus(isActive, showAllLayers, phaseId) {
      if (
        (showAllLayers && phaseId == this.$store.state.general.phaseId) ||
        (showAllLayers && isActive)
      ) {
        return true;
      } else if (!showAllLayers && isActive) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    ...mapState(['gmaps', 'phases', 'general']),
    ...mapActions(['layers/toggleGmLayer', 'phases/fetchColors']),
    layersFiltered: function () {
      return _.filter(this.layers, (layer) => {
        if (
          layer.isActive == 1 ||
          layer.phaseId == this.$store.state.general.phaseId
        ) {
          return true;
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.switchLayer--all {
  font-weight: 600;
}
</style>
